import React from 'react';
import { makeStyles } from '@material-ui/core';
import WealthCreateGuesser from '../../base/components/guesser/wealth-create.guesser';
import GroupForm from './components/GroupForm';
import { useTransformGroupData } from './components/utils';

const GroupCreate = (props) => {
  const classes = useStyles();
  const transformGroupData = useTransformGroupData();

  return (
    <WealthCreateGuesser {...props} transform={transformGroupData} custom className={classes.wrapper}>
      <GroupForm />
    </WealthCreateGuesser>
  );
};

export default GroupCreate;

const useStyles = makeStyles({
  wrapper: {
    maxWidth: '960px',
    width: '100%',
    margin: 'auto',
  },
});
